import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import NavigationBar from './../grocery/nav';
import toast from "react-hot-toast";
import OfferCard from './offer.js'
import firebase from 'firebase/compat/app';
import { applyBOGO, groupPricedByProduct } from '../hooks/bogo';
import CcavenuePayment from './../assist/ccavenuepayment.jpg';
import {TimeLeftUi, TimerCount} from './productpage.js';
import Triologo from "./../assist/triokzzlohgo.svg"
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MESURMENTID,
        databaseURL: "https://loginwithphone-9fb64.firebaseio.com/"
};
// Initialize Firebase

firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();

function StepBadge({ step, current, label }) {
    const done = current > step
    const active = current === step
    return (
      <div className="flex flex-col items-center gap-1">
        <div className={`w-9 h-9 rounded-full flex items-center justify-center font-poppins font-black text-sm transition-all ${done ? "bg-green-500 text-white" : active ? "bg-violet-700 text-white shadow-lg shadow-violet-200" : "bg-gray-100 text-gray-400"}`}>
          {done ? (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
          ) : step}
        </div>
        <span className={`text-[10px] font-semibold whitespace-nowrap ${active ? "text-violet-700" : done ? "text-green-600" : "text-gray-400"}`}>{label}</span>
      </div>
    )
  }

const Paymentgetway = () => {
    const navigate = useNavigate()
    const userstate = useLocation()
    const [step, setStep] = useState(1)
    const [stateofcountry, setstateofcountry] = useState("")
    const [OrderId, setOrderId] = useState("")
    const [HashPhone, setHashPhone] = useState(null)
    const [subTotal, setSubTotale] = useState("")
    const [HashEmail, setHashemail] = useState("")
    const [loading, setLoading] = useState(false);
    const [locationResult, setlocationResult] = useState([]);
    const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
    let ListOfOrdered = useSelector(state => state.allProducts.order)
    const [showChild, setShowChild] = useState(false);
    const [show, setshow] = useState(false);
    const [showloader, setshowloader] = useState(false);
    const [final, setfinal] = useState("");
    const [varified, setverified] = useState(false);
    const [otp, setotp] = useState(new Array(6).fill(''));
    // let session = JSON.parse(localStorage.getItem('PHONEOTPINFO'))
    const [session, setSession] = useState(null);
    const [subtotal, setSubTotal] = useState(0);

    // inside your component, derive this from addtocards for buy 1 get 1 free items 
    const { pricedUnits, totalOriginal, totalPayable, totalDiscount } = applyBOGO(ListOfOrdered || []);
    const groupedForDisplay = groupPricedByProduct(pricedUnits);
// console.log(Math.trunc(subtotal)+OrderId)
    useEffect(() => {
        const stored = localStorage.getItem('PHONEOTPINFO');
        if (stored) {
            setSession(JSON.parse(stored));
        }
        window.scrollTo(0, 0);
    }, []);

    // let siginUserInfo = JSON.parse(localStorage.getItem('signiniNFO'))
    // console.log(ListOfOrdered)

    // detect pincode and postal code via googleApi
    useEffect(() => {
        locationResult && locationResult.map((res, i) => {
            // console.log(res)
            if (res.types[0] == "route") {
                setValue('billing_address', res.formatted_address)
                // console.log(res.formatted_address)
            }
            if (res.types[0] == "postal_code") {
                setValue('delivery_zip', res.address_components[0].long_name)
                // console.log(res.address_components[0].long_name)
            }
        })
    }, [locationResult])

    //verify otp
    let phonenumber = watch('delivery_tel')
    useEffect(() => {
        if (phonenumber != null) {
            const timer = setTimeout(() => {
                setShowChild(true);
                const inputField = document.getElementById('delivery_tel');
                //   inputField.setAttribute('readonly', 'readOnly');
            }, 1000);
        }
        // Show after 3 seconds
    }, [phonenumber])


    const signin = async () => {
        try{
        if (phonenumber === "" || phonenumber.length < 10) return;
        setshowloader(true)

        // let verify = new firebase.auth.RecaptchaVerifier(
        //     'recaptcha-container');
        let verifyed = await new firebase.auth.RecaptchaVerifier(
            'recaptcha-container', {
            size: "invisible",
            callback: function (response) {
                console.log('workrs')
            }
        })
        verifyed.render()
        verifyed.verify()
        // console.log("phonenumber ", phonenumber, verifyed)
        firebase.auth().signInWithPhoneNumber(`+91${phonenumber}`, verifyed)
            .then((result) => {
                setfinal(result);
                toast(
                    <span>
                        <b>OTP Sent To Your Mobile Number</b>
                    </span>,
                    {
                        icon: '😀☞',
                    },
                    {
                        duration: 3000,
                    }
                )
                setshow(true)
            })
            .catch((err) => {
                alert(err);
                // window.location.reload();
            });
        }catch (err) {
            console.error("getProducts error:", err);
            // 3. Tell the component something went wrong
            // dispatch({ type: 'GET_PRODUCTS_ERROR', payload: err.message });
          }
    };

    const ValidateOtp = async () => {
        if (otp === null || final === null) return;
        await final
            .confirm(otp)
            .then((result) => {

                localStorage.setItem('PHONEOTPINFO', JSON.stringify(result && result.user && result.user.multiFactor && result.user.multiFactor.user))

                //    setotpResult(result)
                // console.log(Object.keys(props).length )
                // if(Object.keys(props).length === 0){
                //     navigate("/paymentgetway")
                //    }else{
                //     props.close()
                //    }
                firebase.auth().signOut().then((r) => {
                    // Sign-out successful.
                    toast(
                        <span>
                            <b>Authenticate successfully, Please submit</b>
                        </span>,
                        {
                            icon: '🤝',
                        }
                    )
                    // sendMessage(result && result.user && result.user.multiFactor && result.user.multiFactor.user)
                    setshowloader(false)
                    setverified(true)
                    if (typeof window.fbq === 'function') {
                        window.fbq('track', 'InitiateCheckout', {
                            content_ids: [ListOfOrdered && ListOfOrdered[0].id],
                            currency: 'INR',
                            num_items: 1,
                            value: Number(ListOfOrdered && ListOfOrdered[0].price)
                        });
                    }
                }).catch((error) => {
                    console.log(error)
                    // An error happened.
                })
            })
            .catch((err) => {
                console.log(err)
                alert("Please Enter Correct OTP");

            });
    };

    useEffect(() => {
        setValue('delivery_tel', session && session.phoneNumber && session.phoneNumber.slice(3, 13))
        // setValue('billing_name', siginUserInfo?.user_name)
        // setValue('billing_email', siginUserInfo?.email)
        // setValue('delivery_name', siginUserInfo?.user_name)
        if(ListOfOrdered && ListOfOrdered[0].imageAlt == ""){
            setValue('merchant_param1', "I accept terms and conditions.")
        } else{
            setValue('merchant_param1', ListOfOrdered && ListOfOrdered[0].imageAlt)
        }

    }, [showChild])


    useEffect(() => {
        // this is for buy 1 get 1 free items
        let subtotals = ListOfOrdered && ListOfOrdered.reduce((acc, curr) => {
            let itemtotal = totalPayable
            return acc = itemtotal
        }, 0)
        // console.log(subtotals, typeof subtotals)
        setSubTotal(subtotals)
    }, [ListOfOrdered])

    // let subtotal = ListOfOrdered && ListOfOrdered.reduce((acc, curr) => {
    //     let itemtotal = curr.price * (curr.count ? curr.count : 1)
    //     return acc += itemtotal
    // }, 0)

    let pincode = watch('delivery_zip')
let address = watch('delivery_address')
let name = watch('billing_name')
let email = watch('billing_email')
let receiver = watch('delivery_name')
const step2Valid = pincode && address
const step1Valid = name && (email && email.includes("@")) && receiver
    useEffect(() => {
        if (pincode) {
            setTimeout(() => {
                axios.get(`https://api.postalpincode.in/pincode/${parseInt(pincode)}`)
                    .then(r => setstateofcountry(r.data))
                    .catch((e) => {
                        console.log(e)
                    })
            }, 100)
        }
    }, [pincode])

    // get pin detail using lang lat via google api
    const getPincodeFromCoordinates = async (latitude, longitude) => {
        setLoading(true);
        // console.log(latitude, longitude)
        try {
            // Replace with your chosen reverse geocoding API endpoint and API key
            // Example using a hypothetical API:&apiKey=AIzaSyBbKGdbge3ma5x8z2cwNVFjFruhcinvX1M
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyD42kig8dMOD1B7SlqJsk_Tuv-ksmjMh-Q`);
            const data = await response.json();

            // Assuming the API response contains a 'pincode' field
            if (data && data.results) {
                // console.log(data)
                setlocationResult(data && data.results);
            } else {
                // setError('Pincode not found for this location.');
                toast('Pincode not found for this location.')
            }
        } catch (err) {
            //   setError('Error fetching pincode: ' + err.message);
            console.log('Error fetching pincode: ' + err.message)
        } finally {
            setLoading(false);
        }
    };

    //   use navigator geolocation for lang latitude
    useEffect(() => {
        const now = new Date();
        const formattedDate = now.toISOString().slice(0, 19).replace(/[-T:]/g, '');
        const randomNum = Math.random().toString(36).substring(2, 10);
        setOrderId(`${randomNum}`);

        // geo location

        // if (navigator.geolocation) {
        navigator && navigator.geolocation && navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                // console.log(position)
                getPincodeFromCoordinates(latitude, longitude);
            },
            (err) => {
                if (err.code === err.POSITION_UNAVAILABLE) {
                    toast("Location is currently unavailable. Please check your network and device settings.", { duration: 400, removeDelay: 1000 });
                } else if (err.code === err.PERMISSION_DENIED) {
                    toast("Location access denied. Please grant permission in your browser settings.", { duration: 400, removeDelay: 1000 });
                } else if (err.code === err.TIMEOUT) {
                    toast("Location request timed out. Please try again.", { duration: 400, removeDelay: 1000 });
                } else {
                    console.log(`Geolocation error: ${err.message}`);
                }
            },
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
        //   } else {
        //     // setError('Geolocation is not supported by your browser.');
        //     console.log('Geolocation is not supported by your browser.')
        //   }

    }, [])

    const PixelApi = async (data) => {
        const eventTime = new Date();
        eventTime.setTime(Date.now()); // Add one hour in milliseconds
        const eventTimeSeconds = Math.floor(eventTime.getTime() / 1000)
        // const formattedTime = eventTime.toLocaleTimeString();
        const str = session && session.phoneNumber && session.phoneNumber.slice(1, 13)
        // console.log("Meta event time set to:", typeof parseInt(number));

        const phoneNumber = session && session.phoneNumber && session.phoneNumber.slice(1, 13);
        const email = data && data.billing_email

        async function hashPhoneNumber(phoneNumber) {
            const encoder = new TextEncoder();
            const data = encoder.encode(phoneNumber);
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            setHashPhone(hashHex)
        }

        async function hashEmail(email) {
            const encoder = new TextEncoder();
            const data = encoder.encode(email);
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            setHashemail(hashHex)
        }
        hashPhoneNumber(phoneNumber)
        hashEmail(email)
        // console.log(HashPhone)
        if (HashPhone !== null) {
            const formData = {
                "data": [
                    {
                        "event_name": "Purchase",
                        "event_time": eventTimeSeconds,
                        "action_source": "website",
                        "user_data": {
                            "em": [
                                HashEmail
                            ],
                            "ph": [
                                HashPhone
                            ]
                        },
                        "attribution_data": {
                            "attribution_share": "0.3"
                        },
                        "custom_data": {
                            "currency": "INR",
                            "value": subtotal + ".00",
                        },
                        "original_event_data": {
                            "event_name": "Purchase",
                            "event_time": eventTimeSeconds
                        }
                    }
                ]
            }

            try {
                const response = await fetch('https://graph.facebook.com/v22.0/232698863167434/events?access_token=EAAJPLdO2cpYBO4ZB9rtidineroerpw50PFvKRZCZA2b7AcuPk1nLmVMv0C8shKberzPZB1DlzFSLTkmOkvCy6WIBl6KmfC2ly9bZCax170J9ni2G11jlPAUdhNbnkL4ENjAxXZAwajuwNt5R5w5MjSM1fRYldbb1fsZAUjtD9t6S1MZC2V9hPEottOl3ZAt5CeoR9cQZDZD', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log('Success:', data);
            } catch (error) {
                console.error('Error:', error);
            }
        }
    }


    const onSubmit = async (data, e) => {
        const currentDate = new Date().toLocaleDateString(
            "en-GB"
        )
        const submitter = e.nativeEvent.submitter; // Get the button that triggered the submit
        const action = submitter.value; // Get the 'value' attribute of the clicked button
        // console.log(data)
        // window.gtag('event', 'Purchase', {
        //     transaction_id: data?.order_id || '',
        //     value: parseInt(ListOfOrdered && ListOfOrdered[0].price+".00"), // REQUIRED, up to 2 decimals optional
        //     currency: 'INR', // REQUIRED
        //   });
console.log("data", data)
        if (action.includes("COD")) {
            await axios.post("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/products", {
                "product_id": 1,
                "billing_name": data && data.billing_name,
                "order_id": data && data.order_id,
                "section": ListOfOrdered,
                "email": data && data.billing_email,
                "phone": data && data.delivery_tel,
                "delivery_name": data && data.delivery_name,
                "billing_address": data && data.delivery_address,
                "street_address": data && data.billing_address,
                "state": data && data.delivery_state,
                "city": data && data.delivery_city,
                "pin_code": data && data.delivery_zip,
                // "payment_success": result.order_status,
                "payment_success": "COD",
                "payment_location": "en",
                "approvedby_admin": "Approved",
                "delivered": false,
                "received": false,
                "merchant_param1": data && data.merchant_param1,
                // "date": result.trans_date,
                "date": currentDate,
                "total": data && data.amount,
                "product_for": data && data.billing_name,
                // "tracking_id": result.tracking_id
                // "tracking_id": "152865758552"
            }).then(r => {
                if (r) {
                    navigate('/thankyoupage', { state: { data, ListOfOrdered } })
                }
            }).catch(e => {
                if (e.status) {
                    navigate('/thankyoupage', { state: { data, ListOfOrdered } }, { replace: true })
                }
                console.log("error:", e)
            })
            PixelApi()
            if (typeof window.fbq === 'function') {
                window.fbq('track', 'Purchase', {
                    content_ids: [ListOfOrdered && ListOfOrdered[0].id], // 'REQUIRED': array of product IDs
                    value: ListOfOrdered && ListOfOrdered.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0) || 0, // REQUIRED, up to 2 decimals optional
                    currency: 'INR', // REQUIRED
                    content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
                });
            }
            // localStorage.clear()
        } else {
            try {
                var form = document.createElement("form");
                form.target = "_self";
                form.method = "POST";
                form.action = "https://api.triokzz.com/ccavRequestHandler";
                var params = {
                    "merchant_id": data && data.merchant_id,
                    "amount": data && data.amount,
                    "billing_address": data && data.billing_address,
                    "billing_email": data && data.billing_email,
                    "billing_name": data && data.billing_name,
                    "delivery_name": data && data.delivery_name,
                    "currency": data && data.currency,
                    "delivery_country": "India",
                    "delivery_address": data && data.delivery_address,
                    "delivery_city": data && data.delivery_city,
                    "billing_city": data && data.delivery_city,
                    "delivery_state": data && data.delivery_state,
                    "billing_state": data && data.delivery_state,
                    "billing_country": "India",
                    "billing_tel": data && data.delivery_tel,
                    "delivery_tel": data && data.delivery_tel,
                    "delivery_zip": data && data.delivery_zip,
                    "billing_zip": data && data.delivery_zip,
                    "language": data && data.language,
                    "order_id": data && data.order_id,
                    "redirect_url": data && data.redirect_url,
                    "cancel_url": data && data.cancel_url
                };

                

                for (var i in params) {
                    if (params.hasOwnProperty(i)) {
                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = i;
                        input.value = params[i];
                        form.appendChild(input);
                    }
                }

                document.body.appendChild(form);
                form.submit();

                setTimeout(() => {
                    window.open('', '_self');
                }, 100);

                await axios.post("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/products", {
                    "product_id": 1,
                    "billing_name": data && data.billing_name,
                    "order_id": data && data.order_id,
                    "section": ListOfOrdered,
                    "email": data && data.billing_email,
                    "phone": data && data.delivery_tel,
                    "delivery_name": data && data.delivery_name,
                    "billing_address": data && data.delivery_address,
                    "street_address": data && data.billing_address,
                    "state": data && data.delivery_state,
                    "city": data && data.delivery_city,
                    "pin_code": data && data.delivery_zip,
                    // "payment_success": result.order_status,
                    "payment_success": "Inprogress",
                    "payment_location": "en",
                    "approvedby_admin": "Approved",
                    "delivered": false,
                    "received": false,
                    "merchant_param1": data && data.merchant_param1,
                    // "date": result.trans_date,
                    // "date": "19/12/2023 01:49:04",
                    "total": data && data.amount,
                    "product_for": data && data.billing_name,
                    // "tracking_id": result.tracking_id
                    // "tracking_id": "152865758552"
                }).then(r => r).catch(e => console.log(e))
                PixelApi()
                // localStorage.clear()
            } catch (e) {
                console.log(e)
            }
        }


        if (typeof window) {
            window.renderOptIn = function () {
                window.gapi.load('surveyoptin', function () {
                    window.gapi.surveyoptin.render(
                        {
                            // REQUIRED FIELDS
                            "merchant_id": 5308690872,
                            "order_id": [ListOfOrdered && ListOfOrdered[0].id],
                            "email": data && data.billing_email,
                            "delivery_country": "IND",
                            "estimated_delivery_date": currentDate
                        });
                });
            }
        }

    }

    return (<div className="">
        {/* {session && session.phoneNumber ? "" : showChild ? <OfferCard setShowChild={setShowChild} /> : ""} */}
        <div className="bg-violet-700 px-5 py-4 flex items-center justify-between flex-shrink-0">
    <img
                                                        className="h-12 w-25"
                                                        src={Triologo}
                                                        width="99" height="100%"
                                                        alt="close"
                                                    />
              <div>
              <div className="flex items-center gap-1.5 text-xs text-green-600 font-semibold">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
            Secure Checkout
          </div>
              </div>
           
            </div>

              <TimerCount />
              <button onClick={() => step > 1 && setStep(1)} className="w-full flex items-center justify-between px-5 py-4">
                <div className="flex items-center gap-3">
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-black ${step > 1 ? "bg-green-500 text-white" : "bg-violet-700 text-white"}`}>
                    {step > 1 ? "✓" : "1"}
                  </div>
                  <span className="font-poppins font-bold text-gray-800">Information</span>
                </div>
                {step > 1 && <span className="text-xs text-violet-600 font-semibold">Edit</span>}
              </button>
        <form
            onSubmit={handleSubmit(onSubmit)}
        // method="POST" name="customerData" action="https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/ccavRequestHandler"
        >
            {/* total payment  */}


        <div className="mt-2 bg-gray-50 px-4 pt-2 lg:mt-0 h-full">
        <div className={`bg-white rounded-2xl border-2 transition-all ${step === 2 ? "border-violet-500 shadow-lg shadow-violet-100" : "border-gray-100"}`}>

            
                <div className="max-w-5xl mx-auto px-4 py-5">
                <div className="flex items-center gap-0 mb-8">
          {[1, 2, 3, 4].map((s, i) => (
            <div key={s} className="flex items-center flex-1">
              <StepBadge step={s} current={step} label={["Delivery", "Contact", "Verify", "Payment"][i]} />
              {i < 3 && <div className={`flex-1 h-0.5 mx-1 transition-colors ${step > s ? "bg-green-400" : "bg-gray-200"}`} />}
            </div>
          ))}
        </div>
                    {step === 2 && ( <div className="px-5 pb-5 space-y-3">
                        <label htmlFor="billing_name" className="text-xs font-semibold text-green-700 mb-1.5 block">Contact information</label>
                    <div className="relative">
                        <input type="text" id="billing_name" {...register("billing_name", { required: true })} className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Full name of card holder" />
                        {errors.billing_name && <span style={{ color: "red" }}>please enter your full name</span>}
                        <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                            </svg>
                        </div>
                    </div>
                    {/* <label htmlFor="billing_email" className="mt-4 mb-2 block text-sm font-medium">Email</label> */}
                    <div className="relative">
                        <input type="email" id="billing_email" {...register("billing_email", {
                            required: true, value: "" || userstate && userstate.state && userstate.state.email, pattern: {
                                value: /\S+@\S+\.\S+/,
                                message: "Entered value does not match email format",
                            },
                        })}
                            //    value={" " || userstate && userstate.state && userstate.state.email}
                            className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="mail@triokzz.com" />
                        {errors.billing_email && <span style={{ color: "red" }}>please enter email id</span>}
                        <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                            </svg>
                        </div>
                    </div>
                    <div className="relative">
                        <input type="text" id="delivery_name" {...register("delivery_name", { required: true })} className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Receiver name" />
                        {errors.delivery_name && <span style={{ color: "red" }}>please enter receiver name</span>}
                        <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z" />
                            </svg>
                        </div>
                    </div>
                 
                    <div className="bg-blue-50 border border-blue-100 rounded-xl px-4 py-3 flex items-start gap-3">
                    <span className="text-blue-500 text-lg mt-0.5">💡</span>
                    <p className="text-xs text-blue-700 leading-relaxed">Enter the name exactly as it appears on your payment card to avoid transaction failures.</p>
                  </div>

                  <button
                    disabled={!step1Valid}
                    onClick={() => setStep(3)}
                    className={`w-full py-3.5 rounded-xl font-poppins font-bold text-sm transition-all ${step1Valid ? "bg-violet-700 text-white hover:bg-violet-800 shadow-md shadow-violet-200" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`}
                  >
                    Continue to Verify →
                  </button>
                  </div>)}
                  </div>
                  </div>

                    {/* <label htmlFor="card-no" className="mt-4 mb-2 block text-sm font-medium">Card Details</label>
                    <div className="flex">
                        <div className="relative w-7/12 flex-shrink-0">
                            <input type="text" id="card-no" {...register("card-no")} className="w-full rounded-md border border-gray-200 px-2 py-3 pl-11 text-sm shadow-sm outline-none focus:z-10 focus:ring-sky-400" placeholder="xxxx-xxxx-xxxx-xxxx" />
                            <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                                <svg className="h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z" />
                                    <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z" />
                                </svg>
                            </div>
                        </div>
                        <input type="text" {...register("credit-expiry")} className="w-full rounded-md border border-gray-200 px-2 py-3 text-sm shadow-sm outline-none focus:z-10 focus:ring-sky-400" placeholder="MM/YY" />
                        <input type="number" {...register("credit-cvc")} className="w-1/6 flex-shrink-0 rounded-md border border-gray-200 px-2 py-3 text-sm shadow-sm outline-none focus:z-10 focus:ring-sky-400" placeholder="CVC" />
                    </div> */}
                    
                    <div className={`bg-white rounded-2xl border-2 transition-all ${step === 1 ? "border-violet-500 shadow-lg shadow-violet-100" : "border-gray-100"}`}>
                    {step === 1 && (  <div className="px-5 pb-5 space-y-3">
                        <label htmlFor="delivery_address" className="text-green-700 text-xs font-semibold text-center">Shipping Address</label>
                    <div className="grid grid-cols-2 gap-3">
                    <div className="flex grid col-span-1 lg:col-span-1  sm:flex-row">
                        <input type="text" {...register("delivery_zip", { required: true })} className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Pincode" />
                    </div>

                    {/* manual delivery address */}
                    {stateofcountry && stateofcountry[0].Status == "Success" ? <div className="relative">
                        <select type="text" {...register("delivery_state", { required: true })} className="w-full px-3 py-3.5 border-2  rounded-xl text-sm text-gray-800 outline-none focus:border-violet-500  focus:bg-white transition-all" placeholder="State">
                            {stateofcountry && stateofcountry[0].PostOffice && stateofcountry[0].PostOffice.map((stateof, i) => <option key={i} value={stateof.Circle}>{stateof.Circle}</option>)}
                        </select>
                        {errors.delivery_state && <span style={{ color: "red" }}>delivery state is required</span>}
                        <select type="text" {...register("delivery_city", { required: true })} className="w-full px-3 py-3.5 border-2  rounded-xl text-sm text-gray-800 outline-none focus:border-violet-500  focus:bg-white transition-all">
                            {stateofcountry && stateofcountry[0].PostOffice && stateofcountry[0].PostOffice.map((stateof, i) => <option key={i} value={stateof.Name}>{stateof.Name}</option>)}
                        </select>
                        {errors.delivery_city && <span style={{ color: "red" }}>delivery city is required</span>}
                    </div> : <div className="relative">
                        <input type="text" {...register("delivery_state", { required: true })} className="w-full px-3 py-3.5 border-2 border-gray-100 rounded-xl text-sm text-gray-800 outline-none focus:border-violet-500  focus:bg-white transition-all" placeholder="delivery state" />
                        <input type="text" {...register("delivery_city", { required: true })} className="w-full px-3 py-3.5 border-2 border-gray-100 rounded-xl text-sm text-gray-800 outline-none focus:border-violet-500  focus:bg-white transition-all" placeholder="delivery city" />

                    </div>}
                    </div>
                    <label htmlFor="delivery_address" className="text-green-700 text-xs font-semibold text-center">Flat / House No. / Society / Building</label>
 
                    <div className="relative">
                        <input type="text" id="delivery_address" {...register("delivery_address", { required: true })} className="block pl-11 w-full rounded-md border-0 text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="e.g. A-204, Green Valley Society" />
                        {errors.delivery_address && <span style={{ color: "red" }}>delivery address is required</span>}
                        <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                            <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                        </div>
                    </div>
               
                    <div className="relative">
                        <input type="text" id="billing-address" {...register("billing_address", { required: true })} className="block pl-11 w-full rounded-md border-0 text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Nearby place/shop/school/Street address.." />
                        {errors.billing_address && <span style={{ color: "red" }}>billing address is required</span>}
                        <div className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center px-3">
                            <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                        </div>
                    </div>

                    <div className="bg-green-50 border border-green-100 rounded-xl px-4 py-3 flex items-center gap-3">
                      <span className="text-green-500">🚚</span>
                      <div>
                        <p className="text-xs text-green-600">Estimated arrival: <strong>before 5 days</strong></p>
                      </div>
                    </div>

                    <button
                      disabled={!step2Valid}
                      onClick={() => setStep(2)}
                      className={`w-full py-3.5 rounded-xl font-poppins font-bold text-sm transition-all ${step2Valid ? "bg-violet-700 text-white hover:bg-violet-800 shadow-md shadow-violet-200" : "bg-gray-100 text-gray-400 cursor-not-allowed"}`}
                    >
                      Continue to Contact →
                    </button>
                    </div>)}
                    </div>
                    {/* <div className=" grid grid-cols-1 lg:grid-cols-1  sm:flex-row">
                        <input type="text" name="delivery_tel" id="delivery_tel"
                            //  value={" " || session && session.phoneNumber && session.phoneNumber.slice(3, 13)} 
                            {...register("delivery_tel", { required: true, maxLength: 10, pattern: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/ })}
                            className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Mobile number" />
                        {errors.delivery_tel && <span style={{ color: "red" }}>please enter your 10 digit mobile number</span>}
                    </div> */}


                    {/* <label htmlFor="delivery_address" className="mt-2 mb-2 block text-sm text-white bg-blue-900 font-medium">Order summary</label> */}



                    <div className={`bg-white rounded-2xl border-2 transition-all ${step === 3 ? "border-violet-500 shadow-lg shadow-violet-100" : "border-gray-100"}`}>
                    {step === 3 && (
                  <div className="px-5 pb-5 space-y-4">
          <label htmlFor="delivery_address" className="text-green-700 text-xs font-semibold text-center">Verify & Pay</label>
                    <div
                style={{ display: show ? "none" : "block" }}
                className="text-black"
            >

<div className="bg-violet-50 border border-violet-100 rounded-xl px-4 py-3">
                      <p className="text-xs text-violet-700 font-medium">📱 We'll send a one-time password to verify it's you. This keeps your account secure.</p>
                    </div>
                <div className="flex items-center justify-center">
                    <button id="dropdown-phone-button" data-dropdown-toggle="dropdown-phone" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-2 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600" type="button">
                        <svg className="w-5 h-5" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#f0f0f0" r="256" /><path d="m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z" fill="#ff9811" /><path d="m256 512c101.493 0 189.19-59.065 230.598-144.696h-461.196c41.408 85.631 129.104 144.696 230.598 144.696z" fill="#6da544" /><circle cx="256" cy="256" fill="#0052b4" r="89.043" /><circle cx="256" cy="256" fill="#f0f0f0" r="55.652" /><path d="m256 187.326 17.169 38.938 42.304-4.601-25.136 34.337 25.136 34.337-42.304-4.601-17.169 38.938-17.169-38.938-42.304 4.6 25.136-34.336-25.136-34.337 42.304 4.601z" fill="#0052b4" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>
                        +91 <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" /></svg>
                    </button>
                    <div className="relative">
                        <div className=" grid grid-cols-1 lg:grid-cols-1  sm:flex-row">
                            <input type="text" name="delivery_tel" id="delivery_tel"
                                //  value={" " || session && session.phoneNumber && session.phoneNumber.slice(3, 13)} 
                                {...register("delivery_tel", { required: true, maxLength: 10, pattern:{
                                    value: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/,
                                    message: "Entered value does not match email format",
                                }  })}
                                maxLength="10"
                                className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" placeholder="Mobile number" />
                            {errors.delivery_tel && <span style={{ color: "red" }}>please enter your 10 digit mobile number</span>}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="p-1 items-center justify-center font-medium bg-violet-700 text-white text-[10px] hover:text-indigo-500"
                        onClick={() => signin()}>
                        Send OTP
                    </button>
                </div>
                <br />

                <br />
                <div id="recaptcha-container"></div>
            </div>
            <div
                style={{
                    display: show ? "block" : "none",
                }}
                className="flex sm:mx-auto sm:w-full sm:max-w-sm bg-gray-50"
            >

                {/* <h2 className="m-5 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 bg-gradient-to-r from-red-400 to-green-300 ">OTP Verification</h2> */}
                {!varified ? <div className="p-2">
                    <header className="p-2">
                        <h1 className="text-2xl font-bold m-2">Mobile Phone Verification <span className="animate-[fade-in-bounce-left_2s_ease-in-out_infinite]">🕰️</span></h1>
                        <p className="text-[15px] text-slate-500">Enter the 6-digit verification code that was sent to your phone number.</p>
                    </header>
                    <input
                        type="text"
                        placeholder={"Enter the OTP you received"}
                        onChange={(e) => {
                            setotp(e.target.value);
                        }}
                        name="otp"
                        autoComplete="one-time-code"
                        maxLength="6"
                        inputMode="numeric"
                        className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    <div className="text-sm text-slate-500 mt-2">Didn't receive code? <a className="font-medium text-indigo-500 hover:text-indigo-600" href="#0">Resend</a></div>
                </div> : ""}
                <br />
                <br />
                {showloader == true ? <button
                    type="button"
                    className="p-1 m-5 font-medium bg-gradient-to-r from-blue-300 via-blue-500 via-violet-700 to-blue-900 text-white hover:text-indigo-500"
                    onClick={() => ValidateOtp()}>
                    Verify Number
                </button> : ""}

            </div>
            {varified && (
                      <div className="bg-green-50 border border-green-200 rounded-xl px-4 py-3 flex items-center gap-3">
                        <span className="text-green-500 text-xl">✅</span>
                        <div>
                          <p className="text-sm font-bold text-green-700">Mobile Verified!</p>
                          <p className="text-xs text-green-600">+91 {phonenumber} is confirmed</p>
                        </div>
                      </div>
                    )}
         <p className="text-[11px] text-gray-400 text-center leading-relaxed">
                      By providing your mobile number, you agree to our{" "}
                      <span className="text-violet-600 font-semibold cursor-pointer">Terms of Service</span> and{" "}
                      <span className="text-violet-600 font-semibold cursor-pointer">Privacy Policy</span>.
                    </p>
                    <table width="100%" height="100" border='1' align="right" className="sr-only">
                        <tbody>
                            <tr>
                                {/* <td>Redirect URL</td> */}
                                <td><input type="hidden" name="redirect_url" {...register("redirect_url", { required: true })} value="https://api.triokzz.com/ccavResponseHandler" />
                                </td>
                            </tr>
                            <tr>
                                {/* <td>Cancel URL</td> */}
                                <td><input type="hidden" name="cancel_url" {...register("cancel_url", { required: true })} value="https://api.triokzz.com/ccavResponseHandler" />
                                </td>
                            </tr>
                            <tr disabled>
                                {/* <td>Merchant Id</td> */}
                                <td><input type="hidden"  {...register("merchant_id", { required: true })} id="merchant_id" value="2976964" /> </td>
                            </tr>
                            <tr>
                                {/* <td>Order Id</td> */}
                                {/* <td><input type="hidden" {...register("order_id", { required: true })} value={((Math.random().toString(10).slice(2)).toString()) || (userstate && userstate.jti.split("").splice(0, 5).join("") + userstate & userstate.exp)} /></td> */}
                                <td><input type="hidden" {...register("order_id", { required: true })} value={Math.trunc(subtotal)+OrderId} /></td>

                            </tr>
                            <tr>
                                <td>Currency</td>
                                <td><input type="text" name="currency" {...register("currency", { required: true })} value="INR" /></td>
                            </tr>
                            <tr>
                                <td>Amount(₹)</td>
                                <td><input type="text" {...register("amount", { required: true })} value={subtotal < 1449 ? (subtotal + (ListOfOrdered ? ListOfOrdered[0].delivery_charge : 0))
:subtotal && subtotal.toString()} readOnly /></td>
                                {/* <td><input type="text" name="amount"  {...register("amount", { required: true })} value="1.00" /></td> */}
                            </tr>
                            <tr>
                                <td>Language</td>
                                <td><input type="text" {...register("language", { required: true })} id="language" value="EN" /></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="flex grid grid-cols-1 lg:grid-cols-1  sm:flex-row">
                    <p className="text-sm font-bold text-green-700">Glad to see your feedback ...!</p>
                        <input type="text" {...register("merchant_param1")} placeholder="Glad to see your feedback ..." className="block pl-11 w-full rounded-md border-0  text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 p-2" />
                    </div>
                    {varified ? <div className="mx-auto flex w-full max-w-lg items-center justify-center">

                        <button className="relative m-2 flex w-full active:translate-y-2  
                 active:border-b-[0px] transition-all duration-150  font-medium text-white text-center">

                            <input type="submit" name="purchase" className="w-full text-xl font-bold rounded-md bg-gradient-to-r from-pink-500 to-violet-500 px-6 py-3 font-medium text-white  transition" value={`Purchase ⇨ ₹ ${subtotal < 1449 ? (subtotal + (ListOfOrdered && ListOfOrdered[0].delivery_charge)) && (subtotal + (ListOfOrdered && ListOfOrdered[0].delivery_charge)).toLocaleString() : subtotal && subtotal.toLocaleString()}.00 💳`} />
                          
                        </button>


                    </div> : ""}
                    {varified && <div>
                    <div className="mx-auto flex w-full max-w-lg items-center justify-center">
                        <button className="relative m-2 flex w-full active:translate-y-2  active:[box-shadow:0_0px_0_0_#1b6ff8,0_0px_0_0_#1b70f841]
                 active:border-b-[0px] transition-all duration-150 [box-shadow:0_5px_0_0_#1b6ff8,0_2px_0_0_#1b70f841] bg-gray-900 font-medium text-white text-center">

                            <input type="submit" name="cod" className="w-full rounded-md bg-violet-700 px-6 py-3 font-medium text-white text-[14px]  transition" value="COD (pay in cash when your order arrives.)" />
                            <div className="m-auto  text-white overflow-hidden rounded-full  mx-auto shadow-lg flex justify-center">
                                💵 
                            </div>
                        </button>
                        
                    </div>

                </div>}
                    </div>)}

         </div>
                    <div className="m-2 space-y-2">
                                         <div className="w-full lg:w-80 flex-shrink-0 space-y-4">
                                   <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
              <div className="bg-gradient-to-r from-violet-700 to-purple-700 px-5 py-4">
                <h3 className="font-poppins font-black text-white text-base">Order Summary</h3>
                {/* <p className="text-violet-200 text-xs">{cartItems.reduce((s, i) => s + i.qty, 0)} items · Delivery by Sep 14–16</p> */}
              </div>
              <div className="p-4 space-y-3">
              {ListOfOrdered && ListOfOrdered.map((list, i)=> {
                         const grouped = groupedForDisplay.find((g) => g.id === list.id);
                return(
                  <div key={list.id} className="flex gap-3 items-center">
                    <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0 bg-gray-50">
                      <img src={list.imageSrc} alt={list.product_name} className="w-full h-full object-cover" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-xs font-semibold text-gray-800 line-clamp-2 leading-tight">{list.product_name}</p>
                      <p className="text-[10px] text-gray-400 mt-0.5">{list.sizes.name} · {list.price} Rs · Qty {list.count}</p>
                    </div>
                    <div className="text-right flex-shrink-0">
                      <p className="text-sm font-bold text-gray-900">Free Qty: {grouped && grouped.freeCount > 0 ? grouped.freeCount : '-'}</p>
                      <p className="text-[10px] text-gray-400 ">  ₹{(grouped ? grouped.payableAmount : list.count * list.price).toLocaleString('en-US')}</p>
                    </div>
                  </div>
                )
})}
              </div>
              <div className="px-4 pb-4 border-t border-gray-100 pt-3 space-y-2">
                <div className="flex justify-between text-sm text-gray-600">
                  <span>Subtotal</span><span>₹{subtotal && subtotal.toFixed(1).toLocaleString()}</span>
                </div>
                <div className="flex justify-between text-sm text-green-600 font-semibold">
                  <span>Saving/Discount</span><span>−₹{totalDiscount.toLocaleString('en-US')}</span>
                </div>

                <div className="flex justify-between text-sm text-gray-600">
                  <span>Delivery</span> {subtotal < 1449 ? <span className="text-green-600 font-semibold">{ListOfOrdered && ListOfOrdered[0].delivery_charge.toFixed(1)} Rs</span> : <span className="text-green-600 font-semibold">FREE</span>}
                </div>
                <div className="border-t border-dashed border-gray-200 pt-2 flex justify-between font-poppins font-black text-gray-900">
                  <span>Total</span><span>₹{subtotal < 1449 ? (subtotal + (ListOfOrdered && ListOfOrdered[0].delivery_charge)) && (subtotal + (ListOfOrdered && ListOfOrdered[0].delivery_charge)).toLocaleString() : subtotal && subtotal.toLocaleString()}</span>
                </div>
                <div className="bg-green-50 rounded-xl px-3 py-2 text-center">
                  <p className="text-green-700 text-xs font-bold">🎉 You save ₹{(totalDiscount).toLocaleString()} on this order!</p>
                </div>
              </div>
              </div>
              </div>
                    </div>
                       {/* Social proof */}
            <div className="bg-violet-50 rounded-2xl border border-violet-100 p-4">
              <p className="text-xs font-bold text-violet-800 mb-2">⭐ Loved by 20,000+ customers</p>
              {[
                { name: "Sunita M.", loc: "Mumbai", text: "Super fast delivery! Quality was amazing." },
                { name: "Rahul K.", loc: "Delhi", text: "Authentic products, exactly as described." },
              ].map(r => (
                <div key={r.name} className="bg-white rounded-xl p-3 mb-2 last:mb-0">
                  <div className="flex items-center gap-1.5 mb-1">
                    <span className="text-xs font-bold text-gray-700">{r.name}</span>
                    <span className="text-[10px] text-gray-400">· {r.loc}</span>
                    <span className="ml-auto text-amber-400 text-xs">★★★★★</span>
                  </div>
                  <p className="text-[11px] text-gray-500">{r.text}</p>
                </div>
              ))}
            </div>


            </div>
        </form>
        <div className="border-t border-gray-100 pt-4">
                      <p className="text-[10px] text-gray-400 text-center mb-2 font-semibold uppercase tracking-wide">Payment processed securely by CCAvenue for Triokzz India</p>
                      <div className="flex items-center justify-center gap-3 flex-wrap">
                        {["Paytm", "VISA", "Mastercard", "Rupay", "Net Banking", "UPI"].map(pm => (
                          <span key={pm} className="bg-gray-100 text-gray-600 text-[10px] font-bold px-2.5 py-1 rounded-lg">{pm}</span>
                        ))}
                      </div>
                    </div>
       
    </div>
    )
}

export default Paymentgetway